import { TrackPageViewParameter } from '@sparknz/tracking';

interface Category {
  id: string;
  name: string;
}

interface TrackProductDetailsPageViewParams {
  primaryCategory: Category;
  groupName: string;
}

export function getProductDetailsPageViewParams({
  primaryCategory,
  groupName,
}: TrackProductDetailsPageViewParams): TrackPageViewParameter {
  return {
    pageName: `shop.productInfoState: ${groupName}`,
    pageType: 'Product Page',
    isVisibleInNav: false,
    breadcrumbs: ['home', 'shop', primaryCategory.name, groupName],
  };
}
